/**
 * health.ts — per-account health FSM aggregation (D-05-03 worst-of).
 */

export type HealthMap = Record<string, string>; // accountId → HealthState string

/** Higher = worse. Used to compute the worst-of health across a creator's accounts. */
export const HEALTH_SEVERITY: Record<string, number> = {
  online: 0,
  connecting: 1,
  reconnecting: 2,
  cf_blocked: 3,
  needs_reauth: 4,
  dead: 5,
};

/**
 * Compute the worst-of health across a creator's accounts.
 *
 * Starts from the server-provided worst-of (already aggregated), then applies
 * any live WS health updates that arrived since the last fetch.
 */
export function computeWorstHealth(
  accounts: { accountId: string }[],
  healthMap: HealthMap,
  serverTabHealth: string,
): string {
  let worst = serverTabHealth;
  for (const acc of accounts) {
    const live = healthMap[acc.accountId];
    if (live) {
      const liveScore = HEALTH_SEVERITY[live] ?? 0;
      const worstScore = HEALTH_SEVERITY[worst] ?? 0;
      if (liveScore > worstScore) worst = live;
    }
  }
  return worst;
}
